import { SET_DPPA, REMOVE_DPPA, SET_STATE, REMOVE_STATE } from "../types";

const setDppa = (dppa) => ({
  type: SET_DPPA,
  dppa,
});

export const setReportDppa = (dppa) => (dispatch) => {
  dispatch(setDppa(dppa));
};

const removeDppa = () => ({
  type: REMOVE_DPPA,
});

export const removeReportDppa = () => (dispatch) => {
  dispatch(removeDppa());
};

const setState = (state) => ({
  type: SET_STATE,
  state,
});

export const setReportState = (state) => (dispatch) => {
  dispatch(setState(state));
};

const removeState = () => ({
  type: REMOVE_STATE,
});

export const removeReportState = () => (dispatch) => {
  dispatch(removeState());
};



// WEBPACK FOOTER //
// ./src/actions/dppaAndState.js